import { IFilter } from "@saleor/components/Filter";
import { AutocompleteFilterOpts, FilterOpts, MinMax } from "@saleor/types";
import { SmopUserTypeCode } from "@saleor/types/globalTypes";
import {
  createAutocompleteField,
  createDateField,
  createTextField
} from "@saleor/utils/filters/fields";
import { defineMessages, IntlShape } from "react-intl";

import { checkUserType } from "../../util";

export enum MerchantSettlementFilterKeys {
  brand = "brand",
  mall = "mall",
  settlementDate = "settlementDate",
  payoutId = "payoutId"
}

export interface MerchantSettlementListFilterOpts {
  settlementDate: FilterOpts<MinMax>;
  mall: FilterOpts<string[]> & AutocompleteFilterOpts;
  brand: FilterOpts<string[]> & AutocompleteFilterOpts;
  payoutId: FilterOpts<string>;
}

const messages = defineMessages({
  brand: {
    defaultMessage: "Brand",
    description: "brand name"
  },
  mall: {
    defaultMessage: "Mall",
    description: "mall name"
  },
  payoutId: {
    defaultMessage: "Payout ID",
    description: "payout id"
  },
  settlementDate: {
    defaultMessage: "Settlement Date",
    description: "settlement date"
  }
});

export function createFilterStructure(
  intl: IntlShape,
  opts: MerchantSettlementListFilterOpts,
  userType: SmopUserTypeCode
): IFilter<MerchantSettlementFilterKeys> {
  return [
    {
      ...createDateField(
        MerchantSettlementFilterKeys.settlementDate,
        intl.formatMessage(messages.settlementDate),
        opts.settlementDate.value
      ),
      active: opts.settlementDate.active
    },
    {
      ...createAutocompleteField(
        MerchantSettlementFilterKeys.mall,
        intl.formatMessage(messages.mall),
        opts.mall.value,
        opts.mall.displayValues,
        true,
        opts.mall.choices,
        {
          hasMore: opts.mall.hasMore,
          initialSearch: "",
          loading: opts.mall.loading,
          onFetchMore: opts.mall.onFetchMore,
          onSearchChange: opts.mall.onSearchChange
        }
      ),
      active: opts.mall.active
    },
    {
      ...createAutocompleteField(
        MerchantSettlementFilterKeys.brand,
        intl.formatMessage(messages.brand),
        opts.brand.value,
        opts.brand.displayValues,
        true,
        opts.brand.choices,
        {
          hasMore: opts.brand.hasMore,
          initialSearch: "",
          loading: opts.brand.loading,
          onFetchMore: opts.brand.onFetchMore,
          onSearchChange: opts.brand.onSearchChange
        }
      ),
      active: opts.brand.active
    },
    {
      ...createTextField(
        MerchantSettlementFilterKeys.payoutId,
        intl.formatMessage(messages.payoutId),
        opts.payoutId.value
      ),
      active: opts.payoutId.active
    }
  ].splice(0, checkUserType(userType));
}
